import { loadState } from '@/store'
import { identifyUserInTracking } from '@/services/tracking'

// Re-entrancy guard: loadState() calls significant state mutations that can trigger watchers, which in turn can call loadUserData again.
// This guard prevents multiple simultaneous executions of loadState.
let _loading = false

export const loadUserData = async (onLogin = false) => {
  if (_loading) return

  _loading = true

  try {
    if (!(await loadState())) {
      return
    }

    identifyUserInTracking(onLogin)
  } finally {
    _loading = false
  }
}
